import React from 'react';
import { DatePicker, Input, Select } from 'antd';
import ProductInput from 'pages/ProposalV3/PropDetail/ProductInput';
import { FilterConfig } from 'types';
import ParListSelect from 'components/ParListSelect';
import FormInput from 'components/FormInput';

type FilterInputProps = {
  config: FilterConfig | any;
  value?: any;
  onChange?: (value: any) => void;
  style?: React.CSSProperties;
};

const FilterInput: React.FC<FilterInputProps> = ({
  config,
  value,
  onChange,
  ...props
}) => {
  switch (config.type) {
    case 'select':
      if (config.key === 'isAuthorized') {
    return (
      <FormInput name="isAuthorized" nolabel className="no-border-radius filter-item mb-0">
        <Select
          allowClear
          showSearch
          placeholder={config.placeholder || 'Sélectionner'}
          options={[
            { label: 'Tous', value: '' },
            { label: 'Oui', value: 'true' },
            { label: 'Non', value: 'false' }
          ]}
          className="no-border-radius mb-0 w-100"
          value={value}
          onChange={onChange}
        />
      </FormInput>
    );
  }
      return config.key === 'PRCODE' ? (
        <FormInput name="prcode" nolabel className="no-border-radius filter-item mb-0">
          <ProductInput className="no-border-radius mb-0 w-100" />
        </FormInput>
      ) : (
        <FormInput name={config.label} nolabel className="no-border-radius filter-item mb-0">
          <ParListSelect
            className="no-border-radius mb-0 w-100"
            parcode={config.key}
          />
        </FormInput>
      );

    case 'date':
      return (
        <FormInput
          name={config.key}
          comcode={config.key}
          className="no-border-radius filter-item mb-0"
          nolabel
        >
          <DatePicker
            format="DD-MM-YYYY"
            placeholder={config.placeholder || 'JJ-MM-AAAA'}
            className="no-border-radius"
            value={value}
            onChange={onChange}
          />
        </FormInput>
      );

    default:
      return (
        <FormInput
          name={config.key}
          comcode={config.key}
          className="no-border-radius filter-item mb-0"
          nolabel
          noSpecialChars
        />
      );
  }
};

export default FilterInput;
